

import type { Action, Nullable } from '../model'
import type { ActionLog } from 'types'

import createReducer from '../createReducer'
import { Actions, type ActionLogs } from './types'





export interface ActionLogReducer {
  actionLog: Nullable<ActionLogs>
}

const defaultState: ActionLogReducer = {
  actionLog: null,
}

export const actionLogReducer = createReducer<ActionLogReducer>(defaultState, {
  [Actions.SET_ACTION_LOG]: (state: Nullable<ActionLogReducer>, action: Action<Nullable<ActionLogs>>) => ({
    ...state,
    actionLog: action.payload,
  }),

  [Actions.RESET_ACTION_LOG]: (state: Nullable<ActionLogReducer>) => ({
    ...state,
    actionLog: null,
  }),
})
